<template>
  <div class="page-con">
    <div>
      <div class="page-con-header clearfix">
        <vxe-button
            status="primary"
            icon="fa fa-save"
            @click="showCreatePayment"
            v-if="authCreate() && cate == 'Collection'"
        >款项收入流程
        </vxe-button>

        <!-- <vxe-button
            status="primary"
            icon="fa fa-save"
            @click="showTempModal"
            v-if="authCreate()"
        >{{ cate == "Collection" ? "导入收款信息" : "导入付款信息"
          }}{{ cate == "SellerPayment" ? "(实际承运人)" : "" }}
        </vxe-button
        > -->

        <vxe-button icon="vxe-icon--refresh" @click="getListData"
        >刷新
        </vxe-button>
        <Button
            icon="md-download"
            @click="download"
            style="margin-left: 10px"
            v-if="authDownload()"
        >导出
        </Button>
        <vxe-toolbar ref="xToolbar1" custom></vxe-toolbar>
      </div>
      <div
          class="finance-header"
          style="display: flex; flex-wrap: wrap; padding-bottom: 10px"
      >
        <span class="finance-span finance-span-time">
          <label style="margin-right: 10px">时间</label>
          <DatePicker
              v-model="startTime"
              type="date"
              placeholder="选择日期"
              style="width: 120px"
          ></DatePicker>
          <i class="line-icon">--</i>
          <DatePicker
              v-model="endTime"
              type="date"
              placeholder="选择日期"
              style="width: 120px"
          ></DatePicker>
        </span>
        <span class="finance-span">
          <label>付款企业</label>
          <Select
              v-model="searchPaymentsName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) => remoteMethod(file,'paymentsNameOptions','twoPayments','queryPaymentsKeyword',1)"
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              (file) => setDefaultOptions(file, 'paymentsNameOptions')
            "
              placeholder="输入付款企业"
          >
            <Option
                v-for="option in paymentsNameOptions"
                :value="option.text"
                :key="option.text"
            >{{ option.text }}</Option
            >
          </Select>
        </span>
        <!--        <span class="finance-span">-->
        <!--          <label>付款帐号</label>-->
        <!--          <Select-->
        <!--              v-model="searchPayAccount"-->
        <!--              multiple-->
        <!--              filterable-->
        <!--              prefix="ios-arrow-down"-->
        <!--              :remote-method="(file) => remoteMethod(file,'payAccountOptions','twoPayments','queryPaymentsKeyword',3)"-->
        <!--              :default-label="[]"-->
        <!--              :loading="searchLoading"-->
        <!--              :max-tag-count="1"-->
        <!--              :max-tag-placeholder="maxTagPlaceholder"-->
        <!--              @on-set-default-options="(file) =>setDefaultOptions(file,'payAccountOptions')"-->
        <!--              placeholder="输入付款帐号"-->
        <!--          >-->
        <!--            <Option v-for="option in payAccountOptions" :value="option.text"-->
        <!--                    :key="option.text">{{ option.text }}</Option>-->
        <!--          </Select>-->
        <!--        </span>-->
        <span class="finance-span">
          <label>收款企业</label>
          <Select
              v-model="searchRecName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) =>remoteMethod(file,'recNameOptions','twoPayments','queryPaymentsKeyword',2)"
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              (file) => setDefaultOptions(file, 'recNameOptions')
            "
              placeholder="输入收款企业"
          >
            <Option
                v-for="option in recNameOptions"
                :value="option.text"
                :key="option.text"
            >{{ option.text }}</Option
            >
          </Select>
        </span>
        <!--        <span class="finance-span">-->
        <!--          <label>收款账号</label>-->
        <!--          <Select-->
        <!--              v-model="searchRecAccount"-->
        <!--              multiple-->
        <!--              filterable-->
        <!--              prefix="ios-arrow-down"-->
        <!--              :remote-method="(file) => remoteMethod(file,'recAccountOptions','twoPayments','queryPaymentsKeyword',4)"-->
        <!--              :default-label="[]"-->
        <!--              :loading="searchLoading"-->
        <!--              :max-tag-count="1"-->
        <!--              :max-tag-placeholder="maxTagPlaceholder"-->
        <!--              @on-set-default-options="(file) =>setDefaultOptions(file,'recAccountOptions')"-->
        <!--              placeholder="输入收款账号"-->
        <!--          >-->
        <!--            <Option v-for="option in recAccountOptions" :value="option.text"-->
        <!--                    :key="option.text">{{ option.text }}</Option>-->
        <!--          </Select>-->
        <!--        </span>-->
        <span class="finance-span">
          <label>业务员</label>
          <Select
              v-model="searchSalesMan"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) =>remoteMethod(file,'salesManOptions','twoPayments','queryPaymentsKeyword',5)"
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              (file) => setDefaultOptions(file, 'salesManOptions')
            "
              placeholder="输入业务员"
          >
            <Option
                v-for="option in salesManOptions"
                :value="option.text"
                :key="option.text"
            >{{ option.text }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>客户名称</label>
          <Select
              v-model="searchClientName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) =>remoteMethod(file,'clientNameOptions','twoPayments','queryPaymentsKeyword',6)"
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              (file) => setDefaultOptions(file, 'clientNameOptions')
            "
              placeholder="输入客户名称"
          >
            <Option
                v-for="option in clientNameOptions"
                :value="option.text"
                :key="option.text"
            >{{ option.text }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>所属公司</label>
          <Select
              v-model="searchCompName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) =>remoteMethod(file,'compNameOptions','twoPayments','queryPaymentsKeyword',7)"
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'compNameOptions')"
              placeholder="输入所属公司"
          >
            <Option
                v-for="option in compNameOptions"
                :value="option.text"
                :key="option.text"
            >{{ option.text }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>创建人</label>
          <Select
              v-model="searchCreateUser"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="(file) =>remoteMethod(file,'createUserOptions','twoPayments','queryPaymentsKeyword',8)"
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions')"
              placeholder="输入创建人"
              style="width: 120px !important"
          >
            <Option
                v-for="option in createUserOptions"
                :value="option.id"
                :key="option.text"
            >{{ option.text }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>收付款编号</label>
          <vxe-input
              v-model="searchFormData.paymentsNum"
              placeholder="输入编号"
              style="width: 120px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>流程编号</label>
          <vxe-input
              v-model="searchFormData.flowNum"
              placeholder="输入流程编号"
              style="width: 120px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>流程类型</label>
          <vxe-select
              v-model="searchFormData.flowTypeStr"
              :options="flowTypeOptions"
              placeholder="全部"
              style="width: 120px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>订单编号</label>
          <vxe-input
              v-model="searchFormData.ordersNum"
              placeholder="输入订单编号"
              style="width: 120px"
          ></vxe-input>
        </span>
        <!--        <span class="finance-span">-->
        <!--          <label>摘要</label>-->
        <!--          <vxe-input v-model="searchFormData.note" placeholder="输入摘要" style="width: 140px"></vxe-input>-->
        <!--        </span>-->
        <span class="finance-span">
          <label>按创建时间</label>
          <vxe-select
              v-model="searchFormData.createTime"
              :options="timeOptions"
              placeholder="选择时间"
              style="width: 200px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>附件筛查</label>
          <vxe-select
              v-model="searchFormData.hasFile"
              :options="fileOptions"
              placeholder="全部"
              style="width: 70px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>清分</label>
          <vxe-select
              v-model="searchFormData.isBindOrder"
              :options="fileOptions"
              placeholder="全部"
              style="width: 70px"
          ></vxe-select>
        </span>
        <span class="finance-span" style="margin-left: auto">
          <Button
              type="primary"
              icon="ios-search"
              @click="getSearchListKey"
              style="border-radius: 5px"
          >搜索</Button
          >
          <Button @click="reset" style="margin-left: 10px; border-radius: 5px"
          >重置</Button
          >
        </span>
      </div>
    </div>

    <div class="list-box common-shadow">
      <vxe-table
          ref="xTable"
          class="table-style"
          stripe
          import-config
          export-config
          highlight-hover-row
          show-overflow
          show-footer
          max-height="650"
          border="none"
          align="center"
          :loading="loading"
          :footer-cell-class-name="footerCellClassName"
          :footer-method="footerMethod"
          :data="tableData"
          @cell-click="cellClickEvent"
          resizable
      >
        <vxe-table-column
            field="id"
            title="序号"
            align="center"
            width="90"
        ></vxe-table-column>
        <!-- <vxe-table-column title=" " align="left" width="20">
          <template slot-scope="{ row }">
            <Dropdown
              trigger="click"
              transfer
              v-if="
                row.aboutId == null &&
                row.isOnline === 0 &&
                row.paymentsState == 2 &&
                !row.ordersId &&
                authClearing() &&
                row.sourceType == 2
              "
            >
              <icon
                type="text"
                custom="iconfont icon-gengduo"
                size="12px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button
                    class="button-gengduo"
                    @click="clearing(row)"
                    v-if="!row.ordersId && authClearing()"
                    >清分
                  </Button>
                  <Button
                    class="button-gengduo"
                    @click="editDetail(row)"
                    v-if="authUpdate()"
                    >编辑</Button
                  >
                  <Button
                    class="button-gengduo"
                    style="color: #ed4014"
                    @click="delEvent(row)"
                    v-if="authRemove()"
                    >删除</Button
                  >
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column> -->
        <vxe-table-column
            field="paymentsNum"
            title="详情编号"
            width="150"
            class-name="link-text"
        ></vxe-table-column>
        <vxe-table-column field="flowNum" title="流程编号" width="130">
          <template slot-scope="{ row }">
            <span
                @click="openProcedureDetailTwo(row.flowId, 2)"
                style="color: #2d8cf0; cursor: pointer"
            >{{ row.flowNum }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="orderNum" title="订单编号" min-width="130">
          <template slot-scope="{ row }">
                    <span @click="openOrder(row)"
                          style="color: #2d8cf0; cursor: pointer">{{ row.ordersNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="addTime"
            title="日期"
            formatter="addTime"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="note"
            title="摘要"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="debiteAmount"
            title="借方金额"
            width="150"
        ></vxe-table-column>
        <vxe-table-column
            field="creditAmount"
            title="贷方金额"
            width="120"
        ></vxe-table-column>
        <vxe-table-column field="balanceAmount" title="余额" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.balanceAmount | numberToMoney }}</span>
          </template>
        </vxe-table-column>
        <!--        <vxe-table-column field="chainNum" title="主订单编号" min-width="150" class-name="link-text"></vxe-table-column>-->
        <vxe-table-column field="compName" title="所属公司" width="200"></vxe-table-column>
        <!--        <vxe-table-column field="paymentsName" title="付款人名称" width="200"></vxe-table-column>-->
        <!--        <vxe-table-column field="recName" title="收款人名称" width="200"></vxe-table-column>-->
        <vxe-table-column
            field="clientName"
            title="客户名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="salesMan"
            title="业务员"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="createUser"
            title="创建人"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="createTime"
            title="创建时间"
            formatter="addTime"
            width="120"
            v-if="isHavePermission('twoPayments:createTimeRec')"
        ></vxe-table-column>
      </vxe-table>
    </div>
    <!--    <vxe-modal-->
    <!--        v-model="isShowCreateCollection"-->
    <!--        width="1300"-->
    <!--        height="760"-->
    <!--        resize-->
    <!--        remember-->
    <!--    >-->
    <!--      <div slot="title">款项收入流程</div>-->
    <!--      <create-collection-->
    <!--          :cate="cate"-->
    <!--          :isShow="isShowCreateCollection"-->
    <!--          :isImport="isImport"-->
    <!--          @close="isShowCreateCollection = false"-->
    <!--          @init="getListData"-->
    <!--      ></create-collection>-->
    <!--    </vxe-modal>-->

    <vxe-modal
        v-model="isShowCollectionDetail"
        width="1300"
        height="680"
        resize
        remember
    >
      <div slot="title">收付款详情</div>
      <collection-detail
          :cate="cate"
          :isShow="isShowCollectionDetail"
          ref="collectionDetail"
          @close="isShowCollectionDetail = false"
          @init="getListData"
      ></collection-detail>
    </vxe-modal>
    <vxe-modal
        v-model="isShowPaymentDetail"
        width="1300"
        height="680"
        resize
        remember
    >
      <div slot="title">收付款详情</div>
      <payment-detail
          :cate="cate"
          :isShow="isShowPaymentDetail"
          ref="paymentDetail"
          @close="isShowPaymentDetail = false"
          @init="getListData"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal
        v-model="receivingDeailModal"
        width="1300"
        height="700"
        position="center"
        title="结算信息"
        showFooter
    >

      <receiving-detail ref="receivingDetail"></receiving-detail>
    </vxe-modal>

    <vxe-modal
        v-model="isShowClearing"
        width="1300"
        height="680"
        resize
        remember
    >
      <div slot="title">收入清分</div>
      <clearing
          :cate="cate"
          :isShow="isShowClearing"
          ref="clearing"
          @close="isShowClearing = false"
          @init="getListData"
      ></clearing>
    </vxe-modal>

    <vxe-modal
        v-model="templateVisible"
        title="收付款信息导入"
        width="1000"
        height="640"
        @close="closeTemplate"
        remember
    >
      <import
          @goImport="goImport"
          @close="closeTemplate"
          ref="modalTemplate"
      ></import>
    </vxe-modal>
    <vxe-modal
        v-model="isShowCarryOverDetail"
        title="结转详情"
        width="1300"
        height="460"
        resize
        remember
    >
      <carry-over-detail
          :isShow="isShowCarryOverDetail"
          ref="carryOverDetail"
          @close="isShowCarryOverDetail = false"
      ></carry-over-detail>
    </vxe-modal>
    <div class="search-filter">
      <vxe-modal
          class="timeModal"
          v-model="open"
          width="460"
          height="400"
          :show-footer="false"
          :showHeader="false"
      >
        <template v-slot>
          <DatePicker
              :open="open"
              confirm
              type="daterange"
              :split-panels="true"
              placeholder
              style="width: 432px"
              @on-change="handleChange"
              @on-clear="handleClear"
              @on-ok="handleOk"
          >
            <span class="date-slot"></span>
          </DatePicker>
        </template>
      </vxe-modal>
    </div>
    <vxe-modal
        v-model="isShowDetail"
        title="发票详情"
        width="1200"
        height="920"
        position="center"
        resize
        remember
    >
      <detail ref="detail" :cate="'Sales'" @close="isShowDetail = false" @init="getListData"></detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from '@/apiProvider'
import $C from "@/consts/index";
import {
  SEARCH_TIME
} from "@/filters/time";
import moment from "moment";
import Import from "@/components/common/Import"; // 导入
import CreateCollection from "@/components/proceduremodal/CollectionProcedure.vue";
import CollectionDetail from "@/views/payment2.0/CollectionDetail.vue";
import getAuthOrization from "@/mixin/getAuthOrization";
import Detail from "@/components/order2.0/Invoice/Detail";
import {
  paymentFooter,
  getBlob,
  saveBlob,
  showLoading,
  hideLoading
} from '@/utils/util'
import openProcedureDetailTwo from "@/mixin/viewOrderDetail";
import Clearing from "./Clearing";
import {
  isEmpty
} from "@/utils/util";
import CarryOverDetail from "@/views/payment2.0/CarryOverDetail.vue";
import Payment from "@/views/payment2.0/Payment";
import PaymentDetail from "@/views/payment2.0/PaymentDetail";
import ReceivingDetail from "@/components/order2.0/Receiving/ReceivingDetail";

const empties = [undefined, '', null, 'null', {},
  []
]

export default {
  mixins: [getAuthOrization, openProcedureDetailTwo],
  name: 'CollectionList',
  components: {
    PaymentDetail,
    Import,
    // CreateCollection,
    CollectionDetail,
    ReceivingDetail,
    Clearing,
    CarryOverDetail,
    Detail
  },
  props: {
    cate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShowDetail: false,
      loading: false,
      searchLoading: false,
      isImport: false,
      queryAction: '',
      deleteAction: '',
      isShowPaymentDetail: false,
      templateVisible: false, //导入
      isShowCreateCollection: false, //添加弹窗
      isShowCollectionDetail: false, //详情弹窗
      isShowImportPayment: false, //导入收付款
      isShowBuyerReceivingDetail: false,
      isShowCarryOverDetail: false,
      receivingDeailModal: false,
      secondReceivingDeailModal: false,
      sellerReceivingDeailModal: false,
      isShowClearing: false,

      tableData: [],
      totalCounts: '',
      totalAmount: '',
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      searchParams: {
        addTimeBegin: '',
        addTimeEnd: '',
        flowTypeOptions: null
      },
      timeVal: "",
      rangeTime: "time",
      open: false,
      startTime: '',
      endTime: '',
      timeOptions: SEARCH_TIME.options,
      fileOptions: $C.HAS_FILE_TYPE.options,
      flowTypeOptions: [
        {
          label: '全部',
          value: null
        }, {
          label: '开票申请流程',
          value: 'KP'
        }, {
          label: '款项收入流程',
          value: 'SL'
        }],
      searchPaymentsName: [],
      searchPayAccount: [],
      searchRecName: [],
      searchRecAccount: [],
      searchSalesMan: [],
      searchClientName: [],
      searchOwnName: [],
      searchCompName: [],
      searchCreateUser: [],
      paymentsNameOptions: [],
      payAccountOptions: [],
      recNameOptions: [],
      recAccountOptions: [],
      salesManOptions: [],
      clientNameOptions: [],
      compNameOptions: [],
      ownNameOptions: [],
      createUserOptions: [],
      searchFormData: {
        paymentsNum: null,
        paymentsName: null,
        payAccount: null,
        recName: null,
        recAccount: null,
        payBankCode: null,
        addTime: null,
        chainNum: null,
        ordersNum: null,
        note: null,
        salesMan: null,
        clientName: null,
        compName: null,
        flowNum: null,
        createUser: null,
        createTime: null,
        hasFile: null,
        isBindOrder: null
      },
      searchFormItems: [{
        field: "paymentsNum",
        title: "收款信息编号",
        span: 4,
        titleAlign: "right",
        itemRender: {
          name: "$input",
          props: {
            placeholder: "输入收款信息编号"
          },
        },
      },
        {
          field: "flowNum",
          title: "流程编号",
          span: 3,
          titleAlign: "right",
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入流程编号"
            },
          },
        },
        {
          field: "payBankCode",
          title: "支付流水号",
          titleAlign: "right",
          span: 3,
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入支付流水号"
            }
          },
        },

        {
          field: "ordersNum",
          title: "订单编号",
          titleAlign: "right",
          span: 3,
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入订单编号"
            }
          },
        },
        {
          field: "note",
          title: "摘要",
          titleAlign: "right",
          span: 2,
          itemRender: {
            name: "$input",
            props: {
              placeholder: "输入摘要"
            }
          },
        },
        {
          field: "createTime",
          title: "按创建时间",
          titleAlign: "right",
          span: 3,
          itemRender: {
            name: "$select",
            props: {
              placeholder: "选择时间",
              transfer: false
            },
            options: SEARCH_TIME.options,
          }
        },
        {
          field: "hasFile",
          title: "附件筛查",
          titleAlign: "right",
          span: 3,
          itemRender: {
            name: "$select",
            props: {
              placeholder: "是否包含附件",
              transfer: false
            },
            options: $C.HAS_FILE_TYPE.options,
          },
        },
        {
          field: "isBindOrder",
          title: "清分",
          titleAlign: "right",
          span: 2,
          itemRender: {
            name: "$select",
            props: {
              placeholder: "是否清分",
              transfer: false
            },
            options: $C.HAS_FILE_TYPE.options,
          },
        },
        {
          align: "right",
          span: 12,
          titleAlign: "left",
          itemRender: {
            name: "$buttons",
            children: [{
              props: {
                type: "submit",
                content: "搜索",
                status: "primary"
              }
            },
              {
                props: {
                  type: "reset",
                  content: "重置"
                }
              },
            ],
          },
        },
      ],
    };
  },
  watch: {
    cate: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.searchFormItems[1].title = val == 'Collection' ? '收款信息编号' : '付款信息编号'
        switch (this.cate) {
          case 'Collection':
            this.queryAction = 'queryPaymentsRecInvoiceList'
            this.deleteAction = 'removePaymentsBuyer'
            break;
          case 'Payment':
            this.queryAction = 'queryPaymentsPayList'
            this.deleteAction = 'removePaymentsSeller'
            break
          case 'SellerPayment':
            this.queryAction = 'queryPaymentsSellerLv2List'
            this.deleteAction = 'removePaymentsSellerLv2'
            break
        }
      }
    },
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  mounted() {
    this.$bus.$on("应收账款2.0", () => {
      this.reset();
      this.startTime = moment().startOf("month").format("YYYY-MM-DD");
      this.endTime = moment().endOf('day').format("YYYY-MM-DD");
    });
    this.startTime = moment().startOf("month").format("YYYY-MM-DD");
    this.endTime = moment().endOf('day').format("YYYY-MM-DD");
  },
  methods: {
    reset() {
      this.searchFormData = {
        paymentsNum: null,
        paymentsName: null,
        payAccount: null,
        recName: null,
        recAccount: null,
        payBankCode: null,
        addTime: null,
        chainNum: null,
        ordersNum: null,
        note: null,
        salesMan: null,
        clientName: null,
        compName: null,
        flowNum: null,
        createUser: null,
        createTime: null,
        hasFile: null,
        isBindOrder: null
      }
      this.startTime = '';
      this.endTime = '';
      this.searchPaymentsName = [];
      this.searchPayAccount = [];
      this.searchRecName = [];
      this.searchRecAccount = [];
      this.searchSalesMan = [];
      this.searchClientName = [];
      this.searchCompName = [];
      this.searchCreateUser = [];
      this.searchOwnName = [];
      this.tableData = [];
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.visible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
        moduleType: 1
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i)
          }
        })
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    init() {
      // this.getListData()
    },
    setSearchParams(searchParams) {
      this.searchParams = searchParams
    },
    async download() {
      if (isEmpty(this.tableData)) {
        this.$XModal.message("先搜索数据")
        return
      }
      showLoading()
      let res = getBlob("/api/order/twoPayments/exportPaymentsRecList", this.searchParams);
      hideLoading()
      await saveBlob("导出应收账款.xls", res.data)
    },
    getSearchListKey() {
      if (this.startTime === '' && this.endTime === '' && this.searchPaymentsName.length === 0 &&
          (this.searchFormData.paymentsNum === '' || this.searchFormData.paymentsNum === null) &&
          (this.searchFormData.flowNum === '' || this.searchFormData.flowNum === null) &&
          (this.searchFormData.payBankCode === '' || this.searchFormData.payBankCode === null) &&
          (this.searchFormData.chainNum === '' || this.searchFormData.chainNum === null) &&
          (this.searchFormData.ordersNum === '' || this.searchFormData.ordersNum === null) &&
          (this.searchFormData.createTime === '' || this.searchFormData.createTime === null) &&
          (this.searchFormData.hasFile === '' || this.searchFormData.hasFile === null) &&
          (this.searchFormData.isBindOrder === '' || this.searchFormData.isBindOrder === null) &&
          this.searchPayAccount.length === 0 &&
          this.searchRecName.length === 0 &&
          this.searchRecAccount.length === 0 &&
          this.searchSalesMan.length === 0 &&
          this.searchClientName.length === 0 &&
          this.searchCompName.length === 0 &&
          this.searchOwnName.length === 0 &&
          this.searchCreateUser.length === 0) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error",
        });
        return
      }
      let obj = this.searchFormData;
      let searchParams = {};
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && key !== "createTime") {
          searchParams[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          searchParams.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          searchParams.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
      });
      searchParams.paymentsName = this.searchPaymentsName;
      searchParams.payAccount = this.searchPayAccount;
      searchParams.recName = this.searchRecName;
      searchParams.recAccount = this.searchRecAccount;
      searchParams.salesMan = this.searchSalesMan;
      searchParams.clientName = this.searchClientName;
      searchParams.compName = this.searchCompName;
      searchParams.ownName = this.searchOwnName;
      searchParams.createUserIds = this.searchCreateUser;
      this.searchParams = searchParams
      this.getListData();
    },
    async getListData() {
      this.loading = true;
      this.searchParams.addTimeBegin = this.startTime === '' ? this.startTime : this.$utils.timestamp(this.startTime);
      this.searchParams.addTimeEnd = this.endTime === '' ? this.endTime : (this.$utils.timestamp(this.endTime) + 86399000);
      let params = empties.includes(this.searchParams) ? {} : this.searchParams
      params.orderBy = 3;
      params.isDesc = 0;
      let res = await $api.twoPayments.request(this.queryAction, params)
      if (res.status == 1) {
        res.data.rows.forEach(row => {
          if (row.paymentsState === 1) {
            row.paymentsNum = row.receiveNum
          }
        })
        this.tableData = res.data.rows;
        let firstRow = {
          debiteAmount: '期初余额：',
          balanceAmount: res.data.countRtnVo.beginBalanceAmount
        }
        this.tableData.unshift(firstRow);
        this.loading = false;
      } else {
        if (empties.includes(res.message)) res.message = '接口异常'
        this.$XModal.message(res.message)
      }
    },
    pageChange(page) {
      this.page.currentPage = page.currentPage
      this.page.pageSize = page.pageSize
      this.getListData()
    },
    footerCellClassName({
                          $rowIndex,
                          column,
                          columnIndex
                        }) {
      return 'footer-cell'
    },
    footerMethod({
                   columns,
                   data
                 }) {
      return paymentFooter({
        columns,
        data
      })
    },
    async cellClickEvent(e) {
      let field = e.column.property
      let row = e.row
      if (field === 'paymentsNum') {
        if (e.row.sourceType === 6) {
          // 打开结转流程
          this.viewCarryOverDetail(e.row.id)
        } else if (e.row.sourceType == 2) {
          if (!this.isHavePermission('PaymentsBuyer2.0')) {
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return;
          }
          this.viewDetail(e.row)
        } else if (e.row.sourceType == 3) {
          if (!this.isHavePermission('PaymentsSeller2.0')) {
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return;
          }
          this.viewPaymentDetail(e.row)
        } else if (e.row.sourceType == 1) {
          if (!this.isHavePermission('twoSettlement:detail')) {
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return;
          }
          this.receivingDeailModal = true;
          this.$refs.receivingDetail.getReceivingDetail({
            id: e.row.id
          });
        } else if (e.row.sourceType == 7) {
          if (e.row.paymentsNum.charAt(0) == "P") {
            if (!this.isHavePermission('PaymentsSeller2.0')) {
              this.$Message["info"]({
                background: true,
                content: "对不起，您没有该权限！"
              });
              return;
            }
            this.viewPaymentDetail(e.row)
          } else if (e.row.paymentsNum.charAt(0) == "I") {
            if (!this.isHavePermission('PaymentsBuyer2.0')) {
              this.$Message["info"]({
                background: true,
                content: "对不起，您没有该权限！"
              });
              return;
            }
            this.viewDetail(e.row)
          }
        } else {
          if (!this.isHavePermission('invoiceSeller2.0:detail')) {
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return;
          }
          this.viewInvoiceDetail(e.row);
        }
      }
    },
    viewInvoiceDetail(row) {
      this.isShowDetail = true
      this.$refs.detail.setEdit(false)
      this.$refs.detail.init(row)
    },
    viewDetail(row) {
      if (!this.isHavePermission('PaymentsBuyer2.0')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      this.isShowCollectionDetail = true
      this.$refs.collectionDetail.setEdit(false)
      this.$refs.collectionDetail.init(row.id)
    },
    viewPaymentDetail(row) {
      if (!this.isHavePermission('PaymentsSeller2.0')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      this.isShowPaymentDetail = true
      this.$refs.paymentDetail.setEdit(false)
      this.$refs.paymentDetail.init(row.id)
    },
    clearing(row) {
      this.isShowClearing = true
      this.$refs.clearing.init(row.id)
    },
    async delEvent(row) {
      let confirm = await this.$XModal.confirm({
        title: '提示',
        message: '是否删除',
        'confirm-button-text': '确定',
        'cancel-button-text': '取消'
      })
      if (confirm == 'cancel') return
      let params = {
        id: row.id
      }
      let res = await $api.twoPayments.request(this.deleteAction, params)
      if (res.status == 1) {
        this.$XModal.message('删除成功')
      }
      this.getListData()
    },
    showCreatePayment() {
      this.isImport = false
      window.open('/procedure/collectionProcedure');
    },
    showTempModal() {
      if (this.cate == 'Collection') {
        this.$refs.modalTemplate.setExport('707托运人付款信息导入模板.xls');
      } else if (this.cate == 'Payment') {
        this.$refs.modalTemplate.setExport('708承运人收款信息导入模板.xls');
      } else if (this.cate == 'SellerPayment') {
        this.$refs.modalTemplate.setExport('709实际供应方收款信息导入模板.xls');
      }
      this.templateVisible = true;
    },
    goImport() {
      this.templateVisible = false;
      this.isImport = true
      this.title = '发票信息导入';
      this.isShowCreateCollection = true
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    authCreate() {
      return this.cate == 'Collection' && (this.isHavePermission('flowInstance:saveFlowForPaymentBuyerTwo') || this.isHavePermission('flowInstance:saveFlowForPaymentBuyerTwoOnline')) ||
          this.cate == 'Payment' && (this.isHavePermission('flowInstance:saveFlowForPaymentSellerTwo'))
    },
    authRemove() {
      return this.cate == 'Collection' && this.isHavePermission('payments:removePaymentsBuyer') ||
          this.cate == 'Payment' && this.isHavePermission('payments:removePaymentsSeller')
    },
    authUpdate() {
      return this.cate == 'Collection' && this.isHavePermission('payments:updatePaymentsBuyer') ||
          this.cate == 'Payment' && this.isHavePermission('payments:updatePaymentsSeller')
    },
    authClearing() {
      return this.isHavePermission('payments:clearingPaymentsBuyer')
    },
    authDownload() {
      return this.cate == 'Collection' && this.isHavePermission('twoPayments:exportPaymentsBuyerList') ||
          this.cate == 'Payment' && this.isHavePermission('twoPayments:exportPaymentsSellerList')
    },
    viewCarryOverDetail(id) {
      this.isShowCarryOverDetail = true;
      this.$refs.carryOverDetail.initDetail(id);
    },
    openOrder(row) {
      let id = row.ordersId;
      if (!this.isHavePermission("ordersTwo:detail")) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      let obj;
      if (row.ordersVersion === 2) {
        obj = {
          name: `订单详情2.0-${id}`,
          path: `/order2/orderdetail/${id}`
        };
      } else if (row.ordersVersion === 4) {
        let obj = {};
        obj.name = `附属订单详情${id}`;
        obj.path = `/subOrder/orderdetail/${id}`;
        window.open(obj.path);
      } else {
        obj = {
          name: `撮合订单详情-${id}`,
          path: `/matching/orderdetail/${id}`
        };
      }

      window.open(obj.path);
      return false;
    },
  },
};
</script>
<style>
.detail-head {
  position: relative;
  height: 50px;
}

.detail-head .payment-tab-title {
  height: 50px;
  line-height: 50px;
  font-weight: normal;
}

.detail-head .payment-tab-title span {
  padding: 0 5px;
  cursor: pointer;
}

.detail-head .payment-tab-title span.on {
  font-weight: 700;
}

.detail-head .tip {
  position: absolute;
  right: 20px;
  top: 0;
  color: #606266;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
}


/* 详情 表格内样式 */
.link-text {
  color: #2D8CF0;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
}

.inner-column {
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  margin: auto;
  line-height: 50px;
}

.inner-column-title {
  background-image: linear-gradient(#F8F8F9, #F8F8F9), linear-gradient(#F8F8F9, #F8F8F9);
  color: #808695;
  background-repeat: no-repeat;
  border-top: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  line-height: 50px;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
}


.large-name {
  text-align: center;
  vertical-align: middle !important;
  position: relative;
  padding: 0;
  clear: both;
}


.large-name-text {
  margin: auto;
  display: inline-block;
  word-wrap: break-word !important;
  word-break: normal !important;
  vertical-align: middle !important;
  width: 100%;
  margin-left: -8px;
  line-height: 24px;
}

.finance-header .finance-span {
  display: inline-block;
  padding-right: 10px;
  margin-top: 10px;
}

.finance-span-time .line-icon {
  display: inline-block;
  width: 32px;
  text-align: center;
}

.finance-header label {
  display: inline-block;
  padding: 0 5px;
  /*color: #999;*/
}

.finance-header .vxe-input--inner,
.finance-header .ivu-input,
.finance-header .ivu-select-selection {
  border-radius: 5px;
  border: 1px solid #dcdee2;
  height: 34px;
  box-sizing: border-box;
}

.finance-header .ivu-select {
  width: 140px;
  height: 34px;
  overflow: hidden;
}

.finance-header .ivu-select-multiple .ivu-tag,
.finance-header .ivu-select-input {
  display: inline-block;
  float: left;
}

.finance-header .ivu-select-default.ivu-select-multiple .ivu-select-selection {
  max-height: 32px;
  border-radius: 5px;
}

.finance-header .ivu-select-prefix i {
  vertical-align: middle;
  position: absolute;
  right: 8px;
  top: 8px;
}

.search-filter .vxe-modal--wrapper.type--modal .vxe-modal--body,
.search-filter
.vxe-modal--wrapper.type--modal
.vxe-modal--body
.vxe-modal--content {
  overflow: hidden;
}

.search-filter .vxe-modal--wrapper.type--modal .vxe-modal--box {
  box-shadow: none;
  background: none;
  border: none;
}
</style>
